<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  // mounted() {
  //   var myCookie="eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ3dCIsImlhdCI6MTUxNzEyMzQ2MiwidWlkIjo5Mzc2MjYwMDMyMDU4NDA4OTYsImlzcyI6IndzIiwidXNlciI6eyJpZCI6OTM3NjI2MDAzMjA1ODQwODk2LCJlbmFibGUiOnRydWUsInJlbWFyayI6bnVsbCwiY3JlYXRlQnkiOm51bGwsImNyZWF0ZVRpbWUiOjE1MTIzODI0MzQwMDAsInVwZGF0ZUJ5IjpudWxsLCJ1cGRhdGVUaW1lIjoxNTE2ODc1MzUyMDAwLCJrZXl3b3JkIjpudWxsLCJuaWNrbmFtZSI6IuWFtOadpeWViiIsImhlYWRpbWd1cmwiOiJodHRwOi8vd3gucWxvZ28uY24vbW1vcGVuL3ZpXzMyL1EwajRUd0dUZlRMN1hLUHBjdHE4OURGYXpFcGZETEt5eXpIc3V6Sk5nY1k5ODVScUNjVHJTQXdMR0V6aEN6amJiM1k3MTNsc1ZNVDBjN1Z0dFJVd1RBLzAiLCJzZXgiOiIxIiwiYmlydGhkYXkiOjE1MTU1MTM2MDAwMDAsInByb3ZpbmNlIjoi5rKz5YyX55yBIiwiY2l0eSI6IuWUkOWxseW4giIsImVtYWlsIjpudWxsLCJtb2JpbGUxIjoiWDRNWjgxTXIyeHdySHNrRmpyRDhOYT09IiwibW9iaWxlMiI6IjJ2Z2VWc1hJN21FTXlTQmVtYWNselZ4bFVOSmF6Q0h1NFpCaXBWeGs1UjFLTFBuRUNibFp2MzFwaE9obm8zVTJkUERiOXZVVkdoUlYwMHZJTXZiTHVNPT0iLCJtb2JpbGUiOiIxODUqKioqNjAxMSIsImxvY2tlZCI6ZmFsc2UsInJlY2VpdmVyTmFtZSI6IumDneWFtOadpSIsInJlY2VpdmVyUGhvbmUiOiIydmdlVnNYSTdtRU15U0JlbWFjbHpWeGxVTkphekNIdTRaQmlwVnhrNVIxS0xQbkVDYmxadjMxcGhPaG5vM1UyZFBEYjl2VVZHaFJWMDB2SU12Ykx1TT09IiwicmVjZWl2ZXJQaG9uZTEiOm51bGwsInJlY2VpdmVyUGhvbmUyIjpudWxsLCJyZWNlaXZlckFkZHJlc3MiOiLllaXlnLDmlrnnrKzkuInnrKzkuInmlrkiLCJpZGVudGlmeU51bWJlciI6IjQyMTM4MTE5OTEwODA4MDA3OSIsImlkZW50aWZ5TnVtYmVyMSI6IjQyMTM4MTE5OTEwODA4KioqKiIsImppZmVuIjo1MDAwMDAsImppbmRvdSI6MzE0MiwibGV2ZWwiOjMsImRldmljZUlkIjpudWxsLCJkZXZpY2VUeXBlIjowLCJkZXZpY2VUYWciOm51bGwsImppZmVuU3RhcnQiOm51bGwsImppZmVuRW5kIjpudWxsLCJqaW5kb3VTdGFydCI6bnVsbCwiamluZG91RW5kIjpudWxsfX0.jOPOpcPCgW_wdDkoj2hUixOFUjF1SN2eIXsp3wH9ajBmdU9ITMPciVXxjReXmRly2TkKe1_AwCm2V9hw1or_Tw"
  //   this.$cookie.set('WTS_TOKEN', myCookie, {expires: 1, path: "/", domain: 'wts9999.net',secure: true});
  // },
  watch: {
      '$route' (to, from) {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
      }
    },
    
}
</script>

<style lang="scss">
    @import './sass/base/reset';
    @import './sass/helper/classes';
    @import './sass/helper/_common';
    @import './sass/helper/spacing';
    @import './sass/helper/layer';
   @import url("../static/iconfont/iconfont.css"); 
  #app {
    width: 100%;
    max-width: 10rem;
    min-height: 100%;
    margin: 0 auto;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue